import Utils from "./utils";

export default class Modal {
  #ui;
  #abortController;
  #isOpen = false;

  get abortController() {
    return this.#abortController;
  }

  get eventTarget() {
    return this.#ui.modal;
  }

  constructor() {
    this.#cacheUiElements();
    this.#ui.modal.modal({ backdrop: "static", keyboard: false, show: false });
  }

  #cacheUiElements() {
    this.#ui = {
      modal: $("#booking-modal"),
      modalContent: $("#booking-modal .modal-content"),
      contentWrap: $("#booking-modal #content-wrap"),
      title: $(".modal-title"),
    };
  }

  async open() {
    this.#abortController = new AbortController();
    this.#bindEvents();

    if (this.#isOpen) {
      // Already open
      return Promise.resolve();
    }

    this.#ui.modal.modal("show");
    // Wait for the modal to fully open
    return await Utils.promisifyEvent(this.#ui.modal, "shown.bs.modal");
  }

  async close() {
    if (this.#isOpen) {
      this.#isOpen = false;

      this.#ui.modal.modal("hide");
      // Wait for the modal to fully close
      return await Utils.promisifyEvent(this.#ui.modal, "hidden.bs.modal");
    }

    // Already closed
    return Promise.resolve();
  }

  #bindEvents() {
    const hideModalHandler = () => {
      this.#abortController.abort();
      $(this.#ui.modal).off("hide.bs.modal", hideModalHandler);
    };

    const shownModalHandler = () => {
      this.#isOpen = true;
      this.scrollToContent();
    }

    // Toggle off/on to ensure bound only once
    $(this.#ui.modal).off("hide.bs.modal").on("hide.bs.modal", hideModalHandler);
    $(this.#ui.modal).off("shown.bs.modal").on("shown.bs.modal", shownModalHandler);
  }

  setContent(title, $cleanContent) {
    this.#ui.title.text(title);
    this.#ui.contentWrap.html($cleanContent);
  }

  scrollToContent() {
    window.scroller.scrollToElemTop(this.#ui.modalContent);
  }
}